/* Keep a product visible if its processed image service cannot respond. */
(function () {
  function originalSource(value, base) {
    try {
      const processed = new URL(value, base);
      if (processed.pathname !== '/apps/illegal-cutouts/image') return null;
      const original = new URL(processed.searchParams.get('src'));
      if (original.protocol !== 'https:') return null;
      const allowed = original.hostname === 'cdn.shopify.com'
        ? original.pathname.startsWith('/s/files/')
        : ['shopillegalshirts.com', 'www.shopillegalshirts.com', 'polandshirts.myshopify.com'].includes(original.hostname)
          && /^\/cdn\/shop\/(files|products)\//.test(original.pathname);
      return allowed ? original.href : null;
    } catch (_) { return null; }
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { originalSource };
  if (typeof document === 'undefined') return;

  function recover(image) {
    if (!image || image.tagName !== 'IMG') return;
    const original = originalSource(image.currentSrc || image.getAttribute('src'), document.baseURI);
    if (!original) return;
    // Remove the failing responsive candidates before replacing src. A failure
    // of the original image will not match the proxy path, so it cannot loop.
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = original;
  }

  document.addEventListener('error', event => recover(event.target), true);
  document.querySelectorAll('img').forEach(image => {
    if (image.complete && image.naturalWidth === 0 && image.getAttribute('src')) recover(image);
  });
})();
